import React from 'react'

import { Flex, Header, Text } from 'govwell-ui'

import { ColorToken } from 'src/constants/theme/types'
import { useTheme } from 'src/hooks/use-theme'

type Props = {
  actions?: React.ReactNode
  city: string
  colorToken?: ColorToken
  customIconUrl?: string
  displayName?: string
}
const AIChatTitle = ({ actions, city, colorToken, customIconUrl, displayName }: Props) => {
  const { getTokenVal } = useTheme()
  const color = colorToken ? getTokenVal(colorToken) : undefined

  const titleContent = (
    <Flex align="center" gap={3}>
      {customIconUrl && (
        <img
          src={customIconUrl}
          alt={`${displayName || city || 'Organization'} logo`}
          className="h-10 w-10 shrink-0 rounded-full object-cover"
        />
      )}
      <Flex direction="column" gap={1} align="start">
        <Text.Body
          className="font-semibold"
          style={{ color }}
        >{`Get Instant Answers with${city ? ` ${city}` : ''} AI`}</Text.Body>
        <Text.BodySmall style={{ color, opacity: 0.85 }}>
          AI can make mistakes. Double-check important details.
        </Text.BodySmall>
      </Flex>
    </Flex>
  )

  return <Header actions={actions} title={titleContent} wrap="nowrap" />
}

export default React.memo(AIChatTitle)
